import { render, staticRenderFns } from "./UiSkeleton.vue?vue&type=template&id=88b5c878"
import script from "./UiSkeleton.vue?vue&type=script&lang=ts"
export * from "./UiSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./UiSkeleton.vue?vue&type=style&index=0&id=88b5c878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports